import { render } from "./ProductSelectionModal.vue?vue&type=template&id=36641fcb"
import script from "./ProductSelectionModal.vue?vue&type=script&lang=js"
export * from "./ProductSelectionModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__